module.exports = __webpack_public_path__ + "img/73e0cf0.jpg";